<div class="px-6 pt-5 pb-4 border-b border-gray-100">
  <h3 class="text-lg font-bold text-site m-0">🎁 {{ data.promotion.title }}</h3>
  <p class="text-sm text-gray-400 mt-1">Choisissez un intervalle de commande</p>
  <div class="mt-2 inline-flex items-center gap-1.5 bg-orange-50 border border-orange-200
              text-orange-700 text-sm font-semibold px-3 py-1.5 rounded-full">
    🛒 Total éligible : {{ data.promoEligibleTotal | number:'1.2-2' }} €
  </div>

</div>

<mat-dialog-content>
  <div class="flex flex-col gap-3">
    <div
      class=" p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">
      <p class="font-semibold mb-1">ℹ️ Produits éligibles pour cette promotion :</p>
      <ul class="list-disc pl-4 space-y-1">
        @for (sel of data.promotion.payload.selections; track sel) {
          <li>
            <span class="font-medium">{{ sel.category?.name || 'Produit' }}</span>
            @if (sel.sizes && sel.sizes.length > 0) {
              <span class="text-blue-600">
                — Taille requise :
                @for (size of sel.sizes; track size; let last = $last) {
                  <span>
                    <strong>{{ size.name }}</strong>@if (!last) {
                    <span>, </span>
                  }
                </span>
              }
            </span>
          }
        </li>
      }
    </ul>
    <p class="mt-2 text-xs text-blue-500">
      ⚠️ Ajoutez ces produits dans la bonne taille pour être éligible.
    </p>
  </div>
  @for (rule of sortedRules; track rule; let i = $index) {
    <div
      class="rounded-xl border-2 p-4 cursor-pointer transition-all duration-200"
      [class.border-orange-500]="selectedRule === rule"
      [class.bg-orange-50]="selectedRule === rule"
      [class.border-gray-200]="selectedRule !== rule"
      [class.bg-white]="selectedRule !== rule"
      (click)="selectRule(rule)">
      <!-- En-tête : radio + min/max + badge réduction -->
      <div class="flex items-center justify-between flex-wrap gap-2">
        <div class="flex items-center gap-2">
          <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0"
            [class.border-orange-500]="selectedRule === rule"
            [class.bg-orange-500]="selectedRule === rule"
            [class.border-gray-300]="selectedRule !== rule">
            @if (selectedRule === rule) {
              <div class="w-2 h-2 rounded-full bg-white"></div>
            }
          </div>
          <div>
            <p class="text-sm font-semibold text-gray-700 m-0">Intervalle {{ i + 1 }}</p>
            @if (rule.min === 0 && rule.max >= 9999) {
              <p class="text-xs text-gray-500 m-0 mt-0.5">
                Tout montant
              </p>
            }

           @else if (rule.max >= 9999) {
              <p class="text-xs text-gray-500 m-0 mt-0.5">
                Au-delà de {{ rule.min | number:'1.2-2' }} €
              </p>
            }


    @else {
              <p class="text-xs text-gray-500 m-0 mt-0.5">
                De {{ rule.min | number:'1.2-2' }} € à {{ rule.max | number:'1.2-2' }} €
              </p>
            }
          </div>
        </div>
        @if (getReductionLabel(rule)) {
          <span
            class="text-sm font-bold px-3 py-1 rounded-full"
            [class.bg-green-100]="isEligible(rule)"
            [class.text-green-700]="isEligible(rule)"
            [class.bg-gray-100]="!isEligible(rule)"
            [class.text-gray-500]="!isEligible(rule)">
            {{ getReductionLabel(rule) }}
          </span>
        }
      </div>
      <!-- Statut éligibilité -->
      <div class="mt-2">
        @if (isEligible(rule)) {
          <div class="text-xs text-green-600 font-medium">
            ✅ Votre panier est éligible à cet intervalle
          </div>
        }
        @if (data.promoEligibleTotal < rule.min) {
          <div
            class="text-xs text-amber-600 font-medium">
            ⚠️ Il manque {{ getMissingAmount(rule) | number:'1.2-2' }} € pour atteindre cet intervalle
          </div>
        }
        @if (data.promoEligibleTotal > rule.max) {
          <div
            class="text-xs text-gray-400 font-medium">
            ⛔ Intervalle dépassé
          </div>
        }
      </div>
      <!-- ✅ Produits offerts — TOUJOURS visible dans chaque intervalle -->
      @if (rule.categories && rule.categories.length > 0) {
        <div
          class="mt-2 pt-2 border-t border-gray-100">
          <p class="text-xs text-gray-500 mb-1.5 font-medium">Produits offerts :</p>
          <div class="flex flex-wrap gap-1.5">
            @for (cat of rule.categories; track cat) {
              <span
                class="text-xs px-2 py-0.5 rounded-full border bg-green-50 text-green-700 border-green-200">
                {{ cat.quantity }}x {{ cat.category?.name }}
                @if (cat.size) {
                  <span> ({{ cat.size.name }})</span>
                }
              </span>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- ══ Catégories produits achetés — visible APRÈS tous les intervalles quand un est sélectionné ══ -->
  <!--    <div *ngIf="selectedRule && data.promotion.payload?.selections?.length > 0"-->
  <!--         class="rounded-xl border-2 border-orange-300 bg-orange-50 p-4">-->

  <!--      <p class="text-xs font-bold text-orange-700 uppercase tracking-wide mb-2.5 m-0">-->
  <!--        🛒 Produits Achétées-->
<!--      </p>-->

<!--      <div class="flex flex-wrap gap-2">-->
<!--        <span-->
<!--          *ngFor="let sel of data.promotion.payload.selections"-->
<!--          class="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border"-->
<!--          [class.bg-white]="isEligible(selectedRule)"-->
<!--          [class.text-orange-700]="isEligible(selectedRule)"-->
<!--          [class.border-orange-300]="isEligible(selectedRule)"-->
<!--          [class.bg-gray-100]="!isEligible(selectedRule)"-->
<!--          [class.text-gray-500]="!isEligible(selectedRule)"-->
<!--          [class.border-gray-300]="!isEligible(selectedRule)">-->
<!--          📦 {{ sel.category?.name }}-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->

</div>

<!-- Message d'erreur -->

</mat-dialog-content>

<div class="px-4 py-4 border-t border-gray-100">
  @if (errorMessage) {
    <div
       class="  mb-1 p-3 bg-red-50 border border-red-200 rounded-xl
              text-sm text-red-700 font-medium text-center">
      ❌ {{ errorMessage }}
    </div>
  }
  <div class="flex gap-2.5 justify-center w-full">
    <button
      [matButton]="themeConfig.appearance.button.cancel"
      class="flex-1 py-2.5"
      (click)="cancel()">
      Annuler
    </button>
    <!--    <button-->
<!--      class="flex-1 py-2.5 px-5 border-none bg-orange-500/70 text-white rounded-lg text-sm-->
<!--             font-semibold cursor-pointer hover:bg-orange-500 disabled:bg-gray-300-->
<!--             disabled:cursor-not-allowed transition-all"-->
<!--      [disabled]="!selectedRule"-->
<!--      (click)="confirm()">-->
<!--      Confirmer-->
<!--    </button>-->
    <button
      [matButton]="themeConfig.appearance.button.action"

      class="flex-1 py-2.5 "

    [disabled]="!errorMessage && !selectedRule"
    (click)="errorMessage ? cancel() : confirm()">
    {{ errorMessage ? "D'accord" : 'Confirmer' }}
  </button>
</div>
</div>
